function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4.964 9.914A1 1 0 116.38 8.5l1.414 1.414 3.535-3.535a1 1 0 011.415 1.414L8.5 12.036a1 1 0 01-1.414 0L4.964 9.914z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgMicro = function SvgMicro(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 18,
      height: 18
    }, props), _ref)
  );
};

export default SvgMicro;